import { PATHS } from "../../../../constants";
import { PushEvent } from "../../../components/NotificationPopUp/PushEvent";
import {
  MenuItemChildren,
  MenuItemLinkInside,
  MenuItemPopupHandler,
} from "./Components";

export const menuItems = [
  {
    id: 1,
    label: "label:employees",
    links: [
      { name: "label:list_employees", link: PATHS.LIST_EMPLOYEES },
      { name: "label:add_employee", link: PATHS.ADD_EMPLOYEE },
    ],
    permission: "users",
    Component: MenuItemChildren,
  },
  {
    id: 2,
    label: "label:objects",
    link: PATHS.LIST_OBJECTS,
    permission: "facilities",
    Component: MenuItemLinkInside,
  },
  {
    id: 3,
    label: "label:magazines_events",
    link: PATHS.MAGAZINES_EVENTS,
    permission: "logs",
    Component: MenuItemLinkInside,
  },
  {
    id: 4,
    label: "label:controllers",
    link: PATHS.CONTROLLERS,
    permission: "control-console",
    Component: MenuItemLinkInside,
  },
  {
    id: 5,
    label: "label:messages",
    Popup: PushEvent,
    permission: "exploitation",

    Component: MenuItemPopupHandler,
  },
  {
    id: 7,
    label: "label:ARMS",
    link: PATHS.ARMS,
    permission: "arms",
    Component: MenuItemLinkInside,
  },
];

